import { format } from 'date-fns';
import DataGrid, {
  HeaderFilter,
  Scrolling,
  Column,
  Editing,
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import React, { useCallback, useEffect, useState } from 'react';
import { BoardBody } from '../../components/BoardBody';
import { BoardHeader } from '../../components/BoardHeader';
import master from '../../services/master';
import { Container } from './styles';

export const Segments: React.FC = () => {
  const [segments, setSegments] = useState<DataSource>();
  const [segmentsDetailId, setSegmentsDetailId] = useState(0);

  const [open, setOpen] = useState(false);

  const loadSegments = useCallback(async () => {
    const segmentsStore = new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        const { data } = await master.get('/master/segments');
        return data.sort((a: any, b: any) => {
          if (a.Name < b.Name) {
            return -1;
          }
          if (a.Name > b.Name) {
            return 1;
          }
          return 0;
        });
      },
      insert: async data => {
        await master.post('master/segments', data);
      },
      update: async (id, data) => {
        await master.put(`master/segments/${id}`, {
          Name: data.Name,
          isActive: data.IsActive,
        });
      },
    });

    setSegments(
      new DataSource({
        store: segmentsStore,
        paginate: true,
        reshapeOnPush: true,
      }),
    );
  }, []);

  useEffect(() => {
    loadSegments();
  }, [loadSegments]);

  const boldTextCells = useCallback(
    e => (
      <p
        style={{
          color: '#333333',
          fontSize: '14px',
          fontWeight: 'bold',
          whiteSpace: 'break-spaces',
        }}
      >
        {e.text}
      </p>
    ),
    [],
  );

  const entryAtCell = useCallback(
    e => (
      <p
        style={{
          color: '#333333',
          fontSize: '14px',
          fontWeight: 'bold',
          whiteSpace: 'break-spaces',
        }}
      >
        {format(Date.parse(e.text || new Date()), 'MMM. do, yyyy')}
      </p>
    ),
    [],
  );

  return (
    <Container>
      <BoardHeader title="Segments" subtitle="Segments" />
      <BoardBody>
        <DataGrid
          keyExpr="id"
          dataSource={segments}
          onCellClick={e => {
            if (e.rowType === 'data') {
              setSegmentsDetailId(e.key);
              setOpen(true);
            }
          }}
        >
          <Editing allowAdding allowUpdating />
          <HeaderFilter visible allowSearch />
          <Scrolling mode="infinite" />
          <Column dataField="Name" cellRender={boldTextCells} />
          <Column
            dataField="CreatedAt"
            allowHeaderFiltering={false}
            allowEditing={false}
            cellRender={entryAtCell}
          />

          <Column
            dataField="IsActive"
            allowHeaderFiltering={false}
            dataType="boolean"
            caption="Is Active?"
            cellRender={boldTextCells}
          />
        </DataGrid>
      </BoardBody>
    </Container>
  );
};
